import React, { useState, useCallback, useMemo } from "react";
import { Tooltip, Typography } from "@mui/material";

import { updateUser } from "../../../../sevices/apiUser";
import { objectToFormData } from "../../../../utils";
import AdminLogo from "../../../../styles/svg/admin.svg";
import UserLogo from "../../../../styles/svg/not-owner.svg";
import { localStorageInstance } from "../../../../utils/localStorage";
import { TooltipName } from "../../../../utils/Enums";
import FormDialog from "../../../../components/Dialog/FormDialog";
import useMutate from "../../../../hooks/useMutate";
import { currentUserId } from "../../../../utils/constants";

const Admin = ({ isSuperAdmin, id }) => {
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const userId = currentUserId();

  const handleCloseDialog = useCallback(() => {
    setOpenDialog(false);
  }, []);

  const handleOpenDialog = useCallback(() => {
    setOpenDialog(true);
  }, []);

  const { mutate: userMutate } = useMutate(updateUser,["users"], () => {},
    () => {
      setLoading(false);
      handleCloseDialog();
    },
    () => {
      setLoading(false);
      handleCloseDialog();
    });

  const handleChangeRole = useCallback(() => {
    const data = objectToFormData({
      role: isSuperAdmin === "Super Admin" ? "User" : "Super Admin",
    });
    setLoading(true);
    userMutate({ id, data });
  }, [isSuperAdmin, id, userMutate]);

  const dialogTitle = useMemo(() => {
    return isSuperAdmin === "Super Admin"
      ? "Confirmation: Withdraw Admin Role"
      : "Confirmation: Grant Admin Role";
  }, [isSuperAdmin]);

  const dialogMessage = useMemo(() => {
    return isSuperAdmin === "Super Admin"
      ? "Are you sure you want to Withdraw Admin Role?"
      : "Are you sure you want to Grant Admin Role?";
  }, [isSuperAdmin]);

  return (
    <>
      {openDialog && (
        <FormDialog
          open={openDialog}
          handleClose={handleCloseDialog}
          handleSubmit={handleChangeRole}
          loading={loading}
          alignActions={"center"}
          buttonTxt={isSuperAdmin == "Super Admin" ? "Withdraw" : "Grant"}
          title={dialogTitle}
          cancelBtn={true}
          fullWidth={true}
        >
          <Typography className="align_text_center mb-2">
            {dialogMessage}
          </Typography>
        </FormDialog>
      )}
      {isSuperAdmin == "Super Admin" ? (
        <Tooltip title={TooltipName.MANAGE_USER.REVOKE_ADMIN_RIGHTS}>
          <img
            src={AdminLogo}
            onClick={userId !== id ? handleOpenDialog : () => ""}
            style={{
              cursor: userId === id ? "not-allowed" : "pointer",
              opacity: userId === id ? 0.6 : 1,
            }}
            alt="admin"
          />
        </Tooltip>
      ) : (
        <Tooltip title={TooltipName.MANAGE_USER.GRANT_ADMIN_RIGHTS}>
          <img
            src={UserLogo}
            onClick={userId !== id ? handleOpenDialog : () => ""}
            style={{
              cursor: userId === id ? "not-allowed" : "pointer",
              opacity: userId === id ? 0.6 : 1,
            }}
            alt="admin"
          />
        </Tooltip>
      )}
    </>
  );
};

const isChangeAdmin = (prevProps, nextProps) => {
  return (
    prevProps?.isSuperAdmin === nextProps?.isSuperAdmin
    && prevProps?.id === nextProps?.id
  );
};

export default React.memo(Admin, isChangeAdmin);
